module.exports = __webpack_public_path__ + "media/images/icon_nav_search_sp-ff9ec18170a8f1517d92d048b8416d51.svg";